export default {
  // Header Section
  "discover_your": "உங்கள்",
  "health_report": "சுகாதார அறிக்கை",
  "astrological_health_insights": "ஜோதிட சுகாதார நுண்ணறிவுகள்",
  "health_report_description": "வேத ஜோதிடத்தின் அடிப்படையில் முழுமையான சுகாதாரப் பகுப்பாய்வைப் பெறுங்கள். உடல் பலவீனங்கள், நோய் முன்நிலை, முன்னெச்சரிக்கை பராமரிப்பு முறைகள் மற்றும் தனிப்பயன் நலன் பரிந்துரைகள் குறித்து தெளிவாக அறிய உதவும்.",

  // Service Information
  "enter_details_for_health_analysis": "சுகாதாரப் பகுப்பாய்விற்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_health_analysis": "முழுமையான சுகாதாரப் பகுப்பாய்வு",
  "service_price": "சேவை விலை",
  "comprehensive_health_analysis_note": "உங்கள் சுகாதார முறைபாடுகளின் ஆழமான ஆய்வு மற்றும் தனிப்பயன் நலன் வழிகாட்டுதல்",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_health_influence": "உங்கள் பெயர் அதிர்வுகள், உங்கள் ஆரோக்கியம் மற்றும் குணமாவதின் முறைபாடுகளை பாதிக்கக் கூடும்",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_health_insights": "ஆரோக்கியம் சார்ந்த கிரக நிலைகளை நிர்ணயிக்க இது அவசியம்",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_critical_for_health": "சுகாதார வீடு கணக்கீடுகளுக்குத் துல்லியமான நேரம் தேவை",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "location_essential_for_health": "இடம், ஆரோக்கியத்தைப் பாதிக்கும் கிரக நிலைகளில் மாற்றம் உண்டாக்குகிறது",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் சுகாதாரப் பகுப்பாய்வு தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Health Features
  "health_vulnerabilities_analysis": "சுகாதார பலவீனங்கள் பகுப்பாய்வு",
  "disease_predisposition_insights": "நோய் முன்நிலை நுண்ணறிவுகள்",
  "preventive_health_measures": "முன்னெச்சரிக்கை சுகாதார முறைகள்",
  "dietary_lifestyle_recommendations": "உணவு & வாழ்க்கைமுறை பரிந்துரைகள்",
  "healing_gemstones_remedies": "குணப்படுத்தும் ரத்தினங்கள் & பரிகாரங்கள்",
  "pdf_download": "முழுமையான PDF அறிக்கை",

  "what_you_get": "உங்கள் சுகாதாரப் பகுப்பாய்வில் உள்ளவை",
  "comprehensive_health_chart": "முழுமையான சுகாதார வரைபடம்",
  "body_system_analysis": "உடல் அமைப்பு பகுப்பாய்வு",
  "preventive_care_guidance": "முன்னெச்சரிக்கை பராமரிப்பு வழிகாட்டுதல்",
  "wellness_enhancement_tips": "நலன் மேம்பாடு குறிப்புகள்",

  // Actions & Buttons
  "pay_and_generate_analysis": "என் சுகாதாரப் பகுப்பாய்வை பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "பகுப்பாய்வு உருவாக்கப்படுகிறது",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "health_analysis_processing": "உங்கள் சுகாதாரப் பகுப்பாய்வை எங்கள் மருத்துவ ஜோதிட நிபுணர்கள் தயாரித்து வருகின்றனர். உங்கள் ஆரோக்கிய முறைபாடுகள் மற்றும் தனிப்பயன் நலன் வழிகாட்டுதல்கள் குறித்து விரிவான நுண்ணறிவுகள் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_12_hours_delivery_note": "உங்கள் விரிவான சுகாதார அறிக்கை 12 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு பகுப்பாய்வு அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் சுகாதாரப் பகுப்பாய்வு தொகுப்பு",
  "detailed_health_report": "முழுமையான சுகாதார அறிக்கை (PDF)",
  "body_system_vulnerability_analysis": "உடல் அமைப்பு பலவீனம் பகுப்பாய்வு",
  "preventive_healthcare_plan": "முன்னெச்சரிக்கை சுகாதார திட்டம்",
  "dietary_wellness_guidelines": "உணவு & நலன் வழிகாட்டுதல்கள்",
  "healing_remedies_recommendations": "குணப்படுத்தும் பரிகாரங்கள் & பரிந்துரைகள்",

  // Visual Content
  "sample_health_analysis": "மாதிரி சுகாதாரப் பகுப்பாய்வு",
  "health_strength_indicator": "சுகாதார வலிமை குறியீடு",
  "sample_health_reading": "இதய நலம் மீது கவனம் கூடிய வலுவான உயிர்ச்சக்தி",
  "sample_health_preview": "உங்கள் தனிப்பயன் சுகாதாரப் பகுப்பாய்வின் முன்னோட்டம் — அமைப்பு நுண்ணறிவுகளுடன்",
  "health_categories": "சுகாதார பிரிவுகள்",

  // Health System Types
  "cardiovascular": "இதய-இரத்த ஓட்டம்",
  "neurological": "நரம்பியல்",
  "respiratory": "மூச்சுக் கோளாறு",
  "digestive": "செரிமானம்",
  "skeletal": "எலும்புக்கூடு",
  "immune_system": "நோய் எதிர்ப்பு அமைப்பு",

  // Status & Processing
  "your_health_analysis_status": "உங்கள் சுகாதாரப் பகுப்பாய்வு நிலை",
  "processing_your_analysis": "உங்கள் சுகாதார முறைபாடுகள் ஆய்வு செய்யப்படுகிறது",
  "analysis_processing_message": "உங்கள் கிரக நிலைகளை எங்கள் மருத்துவ ஜோதிட நிபுணர்கள் ஆய்ந்து, சுகாதார பலவீனங்கள் மற்றும் நலன் பரிந்துரைகளைத் தயாரித்து வருகின்றனர்.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_12_hours": "அறிக்கை 12 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "சுகாதார ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து பிறப்பு விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "பகுப்பாய்வு செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவுடன் தொடர்புகொள்ளுங்கள்.",

  // Health-Specific Elements
  "sixth_house": "6ஆம் வீடு (சுகாதார வீடு)",
  "eighth_house": "8ஆம் வீடு (நெடுங்கால நோய்கள்)",
  "twelfth_house": "12ஆம் வீடு (மருத்துவமனை/தங்குதல்)",
  "ascendant_health": "லக்னம் & மொத்த உயிர்ச்சக்தி",
  "moon_health": "சந்திரன் & மனநலம்",
  "mars_energy": "செவ்வாய் & உடல் சக்தி",

  // Body Systems Analysis
  "circulatory_system": "இரத்த ஓட்ட அமைப்பு",
  "nervous_system": "நரம்பு அமைப்பு",
  "respiratory_system": "மூச்சு அமைப்பு",
  "digestive_system": "செரிமான அமைப்பு",
  "musculoskeletal_system": "தசை-எலும்பு அமைப்பு",
  "endocrine_system": "உள்சுரப்பி அமைப்பு",
  "reproductive_system": "பெருக்க அமைப்பு",
  "excretory_system": "வெளிப்படுத்தும் அமைப்பு",

  // Health Vulnerabilities
  "genetic_predispositions": "மரபணு முன்நிலைகள்",
  "chronic_condition_risks": "நெடுங்கால நிலை அபாயங்கள்",
  "acute_illness_patterns": "விரைவான நோய் முறைபாடுகள்",
  "mental_health_factors": "மனநலம் சார்ந்த காரணிகள்",
  "stress_vulnerability": "மனஅழுத்த பலவீனப் பகுதிகள்",
  "injury_prone_areas": "காயம் ஏற்படும் வாய்ப்பு பகுதிகள்",

  // Preventive Measures
  "early_warning_signs": "ஆரம்ப எச்சரிக்கை அறிகுறிகள்",
  "regular_checkup_schedule": "வழக்கமான சோதனை அட்டவணை",
  "screening_recommendations": "சுகாதார ஸ்க்ரீனிங் பரிந்துரைகள்",
  "vaccination_guidance": "தடுப்பூசி வழிகாட்டுதல்",
  "lifestyle_modifications": "வாழ்க்கைமுறை மாற்றங்கள்",
  "exercise_prescriptions": "உடற்பயிற்சி பரிந்துரைகள்",

  // Dietary Recommendations
  "constitutional_diet": "உடலமைப்புக்கு ஏற்ற உணவு திட்டம்",
  "foods_to_include": "சேர்க்க வேண்டிய உணவுகள்",
  "foods_to_avoid": "தவிர்க்க வேண்டிய உணவுகள்",
  "meal_timing": "சிறந்த உணவு நேர அமைப்பு",
  "seasonal_adjustments": "஋ துகால உணவு மாற்றங்கள்",
  "supplementation_needs": "செருக்கும் (Supplement) தேவை",

  // Lifestyle Guidance
  "sleep_patterns": "சிறந்த உறக்க முறைபாடுகள்",
  "exercise_routine": "பரிந்துரைக்கப்பட்ட உடற்பயிற்சி நடைமுறை",
  "stress_management": "மனஅழுத்த மேலாண்மை முறைகள்",
  "work_life_balance": "வேலை-வாழ்க்கை சமநிலை",
  "environmental_factors": "சுற்றுப்புற சுகாதாரக் காரணிகள்",
  "social_health": "சமூக & உணர்ச்சி நலம்",

  // Healing & Remedies
  "ayurvedic_remedies": "ஆயுர்வேத பரிகாரங்கள்",
  "herbal_recommendations": "மூலிகை பரிந்துரைகள்",
  "gemstone_therapy": "ரத்தின சிகிச்சை",
  "color_therapy": "நிற சிகிச்சை",
  "sound_healing": "ஒலி குணப்படுத்தல்",
  "yoga_practices": "சிகிச்சைமுறை யோகா பயிற்சிகள்",
  "meditation_techniques": "குணப்படுத்தும் தியான முறைகள்",
  "breathing_exercises": "பிராணாயாமம் & சுவாச பயிற்சிகள்",

  // Mental Health
  "psychological_patterns": "மனவியல் முறைபாடுகள்",
  "emotional_balance": "உணர்ச்சி சமநிலை",
  "mental_clarity": "மனத் தெளிவு மேம்பாடு",
  "memory_concentration": "நினைவாற்றல் & ஒருமைப்படுதல்",
  "anxiety_management": "அவசரக்கோப மேலாண்மை",
  "depression_prevention": "மனச்சோர்வு தடுப்பு",

  // Timing & Cycles
  "health_cycles": "தனிப்பட்ட சுகாதாரச் சுழற்சிகள்",
  "vulnerable_periods": "அபாயம் அதிகமான காலங்கள்",
  "recovery_periods": "இயல்பான குணமாவதற்கான காலங்கள்",
  "optimal_treatment_timing": "சிகிச்சைக்கான சிறந்த நேரம்",
  "surgery_timing": "அறுவை சிகிச்சை நேர நிர்ணயம்",
  "detox_periods": "டிடாக்ஸ் காலங்கள்",

  // Age-Related Health
  "childhood_health": "சிறுவயது சுகாதாரம்",
  "adolescent_health": "மைதுன வயது சுகாதாரப் பிரச்சினைகள்",
  "adult_health": "பெரியோர் சுகாதார பராமரிப்பு",
  "middle_age_concerns": "நடு வயது சுகாதார கவலைகள்",
  "senior_health": "மூப்பில் சுகாதார வழிகாட்டுதல்",
  "longevity_factors": "நீடித்த ஆயுள் காரணிகள்",

  // Women's Health
  "menstrual_health": "மாதவிடாய் சுகாதாரம்",
  "fertility_factors": "கர்ப்பத்திறன் காரணிகள்",
  "pregnancy_guidance": "கர்ப்பகால சுகாதார வழிகாட்டுதல்",
  "menopause_management": "மாதவிடாய் நிறைவு மேலாண்மை",
  "hormonal_balance": "ஹார்மோன் சமநிலை",

  // Men's Health
  "vitality_enhancement": "உயிர்ச்சக்தி மேம்பாடு",
  "prostate_health": "புரோஸ்டேட் சுகாதாரம்",
  "testosterone_balance": "டெஸ்டோஸ்டிரோன் சமநிலை",
  "cardiovascular_focus": "இதய-இரத்த ஓட்ட கவனம்",
  "stress_related_issues": "மனஅழுத்தம் சார்ந்த பிரச்சினைகள்",

  // Specialty Areas
  "skin_health": "தோல் & அழகு சுகாதாரம்",
  "eye_health": "கண் ஆரோக்கியம்",
  "dental_health": "பல் சுகாதாரம்",
  "hair_health": "முடி சுகாதாரம்",
  "joint_health": "கூட்டு எலும்பு சுகாதாரம்",
  "metabolic_health": "மெட்டபாலிக் சுகாதாரம்",

  // Emergency Preparedness
  "health_emergencies": "சுகாதார அவசரத் தயார்பு",
  "first_aid_guidance": "முதல் உதவி வழிகாட்டுதல்",
  "emergency_contacts": "அவசர வைத்திய தொடர்புகள்",
  "medication_management": "மருந்து மேலாண்மை",
  "allergy_alerts": "அலெர்ஜி எச்சரிக்கைகள்",

  // Holistic Wellness
  "mind_body_connection": "மனம்-உடல் இணைப்பு",
  "spiritual_healing": "ஆன்மீக குணப்படுத்தும் முறைகள்",
  "energy_healing": "எனர்ஜி ஹீலிங் முறைகள்",
  "chakra_balancing": "சக்ரா சமநிலை",
  "aura_cleansing": "ஆரா சுத்திகரம்",
  "holistic_integration": "முழுமையான சுகாதார ஒருங்கிணைப்பு"
};
